<template>
  <div>
    <section class="BasicHeader BasicHeader--default ContentPageHeader">
      <div class="Header-topNav">
        <div class="Header-topNav-inner">
          <div style="text-align: center">
            <a class="BlueOceanLogo">
              英签智能填表
            </a>
          </div>
        </div>
      </div>
    </section>
    <div v-if="content">
      <DetailTable ref="detailTable"></DetailTable>
      <div class="footer">
        <a-row>
          <a-col :xs="{ span: 11, offset: 1 }" :sm="{ span: 11, offset: 1 }" :md="{ span: 11, offset: 1 }" :lg="{ span: 11, offset: 1 }" :xl="{ span: 3, offset: 9 }" :xxl="{ span: 3, offset: 9 }">
            <a-button style="width: 100%;" @click="handleValid">
              验证
            </a-button>
          </a-col>
          <a-col :xs="{ span: 11, offset: 1 }" :sm="{ span: 11, offset: 1 }" :md="{ span: 11, offset: 1 }" :lg="{ span: 11, offset: 1 }" :xl="{ span: 3, offset: 1 }" :xxl="{ span: 3, offset: 1 }">
            <a-button type="primary" style="width: 100%;" @click="handleSave">
              确定保存
            </a-button>
          </a-col>
        </a-row>
      </div>
      <a-back-top/>
    </div>
    <div v-if="result">
      <a-result status="success"
                title="已经成功提交 英签智能填表!"
                :sub-title=subTitle>
      </a-result>
    </div>
  </div>
</template>

<script>

import DetailTable from "@/components/ukDs/DetailTable";

export default {
  name: "Link",
  components: {DetailTable},
  data() {
    return {
      content: true,
      result: false,
      id: '',
      subTitle: '',
      url: {
        get: window._CONFIG['domainURL'] + "/power/ukApplicant",
      }
    }
  },
  mounted() {
    document.title = "英国填表";
    this.content = true;
    this.result = false;
    this.id = this.$route.query.id
    this.subTitle = "订单编号: " + this.id + " 系统处理与提交大使馆要  30-50 分钟, 请耐心等待.";

    let that = this;
    this.$axios.get(this.url.get + "?id=" + this.id)
        .then((res) => {
          let response = res.data;
          if (!response) {
            return;
          }
          if (!(response.status === '开始' || response.status === '失败')) {
            that.content = false;
            that.result = true;
          }
          that.$refs.detailTable.init(response);
        });
  },
  methods: {
    handleComplete() {
      this.content = false;
      this.result = true;
    },
    handleSave() {
      this.$refs.detailTable.handleDraft();
    },
    handleValid() {
      this.$refs.detailTable.handleValid();
    },

  }
}
</script>


<style scoped>

.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;

  padding: 10px 16px;
  text-align: right;
  background: white;
  border-top: 1px solid #e8e8e8;
  border-radius: 0 0 4px 4px;
}

.ant-menu-horizontal > .ant-menu-item > a:hover, .ant-menu-horizontal > .ant-menu-item > a {
  color: white;
}

.Header-topNav-inner nav {
  display: flex;
  height: 100%;
}

.ContentPageHeader {
  color: white;
}

.BasicHeader--default {
  background: #4a90e2;
}

.BasicHeader {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
}

.Header-topNav {
  width: 100%;
  background-color: rgba(0, 0, 0, 0.1);
}

.Header-topNav-inner {
  height: 48px;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding-right: 15px;
  padding-left: 15px;
}

.BlueOceanLogo, .BlueOceanLogo:hover {
  display: flex;
  color: white;
  text-decoration: none;
  align-items: center;
  font-size: 20px;
  position: relative;
  top: -1px;
  font-weight: bold
}

</style>
